/**
 *
 * Asynchronously loads the component for Pricing
 *
 */

import { lazyLoad } from 'src/utils/loadable';

export const DefaultLayout = lazyLoad(
  () => import('./index'),
  (module: { DefaultLayout: any }) => module.DefaultLayout,
);
